import { WaydFrequencyData } from "./types";
import { grey } from "@mui/material/colors";

const getGrayFromPercentile = (percentile: number): string => {
  if (percentile >= 80) return grey[700];
  if (percentile >= 60) return grey[600];
  if (percentile >= 40) return grey[500];
  if (percentile >= 20) return grey[400];
  return grey[300];
};

export const getWaydFrequencyChartData = (data: WaydFrequencyData[]) => {
  return data.map(({ role, rolePercentage, rolePercentile }) => ({
    id: role,
    label: role,
    value: rolePercentage,
    color: getGrayFromPercentile(rolePercentile),
  }));
};